import { IFilterOption } from "@faire/web-api--source/indigofair/data/IFilterOption";

export const generateSelectedCategoryArray = (
  filterOption: IFilterOption
): IFilterOption[] => {
  let result = [] as IFilterOption[];
  const subOptions = filterOption.sub_options;

  subOptions?.forEach((subOption) => {
    result = [...result, ...generateSelectedCategoryArray(subOption)];
  });

  if (
    (filterOption.is_selected || Object.keys(result).length > 0) &&
    filterOption.key
  ) {
    result = [filterOption, ...result];
  }
  return result;
};
